// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"a986cd76","107":"f7141b64","418":"e909fbbe","453":"258b012d","489":"6c13609e","666":"a0f113aa","722":"2139c9d6","781":"2735c4d7"}[chunkId] + ".chunk.js";
};